import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useCompanyContext } from '../../../../context/CompanyContext';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { fetchSCLatestPayments } from '../../../../services/accounting/SubcontractsService';
import SCLatestPaymentsTable from './SCLatestPaymentsTable';
import { useFormContext } from 'react-hook-form';
import { SubcontractsFilters } from '../SCFilters';

const SCLatestPaymentsContainer = React.forwardRef<HTMLDivElement>(
  (props, ref) => {
    const { selectedCompany } = useCompanyContext();
    const { watch } = useFormContext<SubcontractsFilters>();
    const filters = watch();
    const isEnabled =
      selectedCompany &&
      ((filters.jobs && filters.jobs.length > 0) ||
        (filters.dates && filters.dates.length > 0) ||
        filters.subcontractor);

    const { data, isFetching, isError } = useQuery({
      queryKey: ['getSCLatestPayments', selectedCompany, filters],
      queryFn: ({ signal }) => {
        const { reportType, jobs, itemsState, ...otherFilters } = filters;

        return fetchSCLatestPayments(
          {
            companyID: selectedCompany!.id,
            jobs: jobs ?? undefined,
            ...otherFilters,
          },
          signal
        );
      },
      refetchOnWindowFocus: false,
      enabled: !!isEnabled,
    });

    if (!isEnabled) {
      return (
        <div className="mt-4">
          <ErrorMessage
            severity="info"
            content={
              'To start the search please select: a Job, a Subcontractor, or a Date range.'
            }
          />
        </div>
      );
    }

    if (isFetching)
      return (
        <div className="text-center mx-auto mt-3">
          <ProgressSpinner />
        </div>
      );

    if (isError)
      return (
        <ErrorMessage
          content={'Failed to obtain data! Please try again later.'}
        />
      );

    return <SCLatestPaymentsTable payments={data ?? []} />;
  }
);

export default SCLatestPaymentsContainer;
